import Button from "../../../../components/button/button";
import { useUserContext } from "../../../utils/userContext";
import { useState } from "react";
import Label from "../../../../components/label/label";
import Input from "../../../../components/input/input";
import IconFA from "../../../../components/icon/icon";
import { Link } from "react-router-dom";


function AddUser() {
    const { saveUser } = useUserContext();
    const [userData, setUserData] = useState({
        prename: '',
        name: '',
        email: '',
        password: '',
        passwordConfirm: ''        
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        saveUser({
            prename: userData.prename,
            name: userData.name,
            email: userData.email,
            password: userData.password,
            passwordConfirm: userData.passwordConfirm
        });
    }

    return (
        <div className='pageContainer'>
            <div className="addUserContainer">
                <div className='adUsDeHeader'>
                    <Link to='/admin/user'><IconFA iconName='arrowLeft' /></Link>
                    <h2>Neuen User hinzufügen</h2>
                </div>
                <p>Gib die Daten des Users ein:</p>
                <div>
                    <Label labelFor="prename" labelValue="Vorname:" />
                    <Input
                        inputType="text"
                        inputId="prename"
                        inputName="prename"
                        inputValue={userData.prename}
                        onChange={(e) => setUserData({ ...userData, prename: e.target.value })}
                        borderColor='black'
                    />
                </div>
                <div>
                    <Label labelFor="name" labelValue="Nachname:" />
                    <Input
                        inputType="text"
                        inputId="name"
                        inputName="name"
                        inputValue={userData.name}
                        onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                        borderColor='black'
                    />
                </div>
                <div>
                    <Label labelFor="email" labelValue="Email:" />
                    <Input
                        inputType="email"
                        inputId="email"
                        inputName="email"
                        inputValue={userData.email}
                        onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                        borderColor='black'
                    />
                </div>
                <div>
                    <Label labelFor="password" labelValue="Passwort:" />
                    <Input
                        inputType="password"
                        inputId="password"
                        inputName="password"
                        inputValue={userData.password}
                        onChange={(e) => setUserData({ ...userData, password: e.target.value })}
                        borderColor='black'
                    />
                </div>
                <div>
                    <Label labelFor='passwordConfirm' labelValue='Passwort bestätigen:' />
                    <Input
                        inputType='password'
                        inputId='passwordConfirm'
                        inputName='passwordConfirm'
                        inputValue={userData.passwordConfirm}
                        onChange={(e) => setUserData({ ...userData, passwordConfirm: e.target.value })}
                        borderColor='black'
                    />
                </div>
                <Button buttonValue='Speichern' onClick={handleSubmit} />
            </div>
        </div>
    );
}

export default AddUser;